import type { KeypointType } from 'shared/lib/tv-game/pose.ts';
import type { RunnerEnvironmentKind } from 'shared/lib/tv-game/types.ts';

export type { RunnerEnvironmentKind };

export type RunnerGameState = 'PREPARING' | 'STARTED' | 'PAUSED' | 'GAME_OVER';
export type RunnerObstacleType = 'JUMP' | 'DUCK' | 'PUNCH' | 'DODGE';
export type RunnerAnimationType = 'WALK' | 'JUMP' | 'DUCK' | 'PUNCH';

export interface RunnerObstacle {
  id: number;
  zPos: number;
  type: RunnerObstacleType;
  lane: number;
  isDestroyed: boolean;
  animationProgress: number;
}

export interface RunnerPlayer {
  lives: number;
  playerZ: number;
  score: number;
  lane: number;
  animationType: RunnerAnimationType;
  animationProgress: number;
}

export interface RunnerFrame {
  gameState: RunnerGameState;
  obstacles: RunnerObstacle[];
  player: RunnerPlayer;
  stageId?: string;
}

export type RunnerCalibNormPoint = { nx: number; ny: number };
export type RunnerCalibNormMap = Map<KeypointType, RunnerCalibNormPoint>;

export interface RunnerDisplayState {
  phase: 'lobby' | 'calibration' | 'playing' | 'paused' | 'gameover';
  frame: RunnerFrame | null;
  stageId: string;
  environment: RunnerEnvironmentKind;
  calibKeypoints: RunnerCalibNormMap;
  detectionProgress: number | null;
}

export function createRunnerInitialState(): RunnerDisplayState {
  return {
    phase: 'lobby',
    frame: null,
    stageId: 'almaty',
    environment: 'video',
    calibKeypoints: new Map(),
    detectionProgress: null,
  };
}
